export default __webpack_public_path__ + "static/media/hamdon_1.bd743a24.jpg";